import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
  selector: 'flo-streaming-hero',
  templateUrl: './streaming-hero.component.html',
  styleUrls: ['./streaming-hero.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StreamingHeroComponent {
  constructor() {}
}
